export const initCountdown = (date: number, targetElem: HTMLElement): void => {
  const timer: ReturnType<typeof setInterval> = setInterval((): void => {
    const now: number = new Date().getTime()
    const distance: number = date - now
    
    const days: number = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours: number = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes: number = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds: number = Math.floor((distance % (1000 * 60)) / 1000)

    targetElem.innerHTML = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's '

    if (distance < 0) {
      clearInterval(timer)
      targetElem.style.display = 'none'
    }
  }, 1000)
}